// material-ui
import { Box, Chip, Stack, Tooltip, useMediaQuery } from '@mui/material';

// Show at most this many project chips before collapsing the rest into a "+N" chip with a
// hover tooltip — keeps the header to a single row regardless of how many projects are assigned.
const VISIBLE_PROJECT_COUNT = 1;

// project-imports
// import Search from './Search';
import Profile from './Profile';
// import Notification from './Notification';

import useConfig from 'hooks/useConfig';
import DrawerHeader from 'layout_vms/mainlayout_vms/Drawer/DrawerHeader';

import { MenuOrientation } from 'config';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { menuOrientation } = useConfig();
  // const Role = localStorage.getItem('role');

  // Sales Managers etc. can be assigned to more than one project, so the header shows a chip
  // per project rather than just the first one. Falls back to the older single-value key for
  // sessions that logged in before this list was stored.
  let projectNames = [];
  try {
    const parsed = JSON.parse(localStorage.getItem('project_names') || '[]');
    if (Array.isArray(parsed)) projectNames = parsed.filter(Boolean);
  } catch (error) {
    projectNames = [];
  }
  if (projectNames.length === 0) {
    const singleProjectName = localStorage.getItem('project_name');
    if (singleProjectName) projectNames = [singleProjectName];
  }

  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  // Profile keeps flexShrink:0 (its own box, unconditionally), so if the chips don't truncate/shrink
  // themselves a long project name paints straight under it instead of stopping short — cap how many
  // chips show and how wide each one gets, tighter on a narrow phone than on tablet/desktop.
  const downSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const visibleCount = downSM ? 1 : VISIBLE_PROJECT_COUNT;

  const visibleProjects = projectNames.slice(0, visibleCount);
  const hiddenProjects = projectNames.slice(visibleCount);

  const projectChipSx = {
    fontWeight: 600,
    bgcolor: 'warning.lighter',
    color: 'warning.darker',
    maxWidth: { xs: 130, sm: 160 },
    '& .MuiChip-label': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  };

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      {projectNames.length > 0 ? (
        // Always show at most a handful of chips, plus a "+N" chip for the rest — this keeps the
        // header to a single row no matter how many projects are assigned or how wide the viewport
        // is, instead of wrapping (which grows a fixed header and hides page content). overflow:
        // 'hidden' plus each chip's own maxWidth/ellipsis stop a long name from painting under Profile.
        <Stack direction="row" spacing={0.75} alignItems="center" sx={{ ml: 1, flexGrow: 1, minWidth: 0, overflow: 'hidden' }}>
          {visibleProjects.map((name) => (
            <Tooltip key={name} title={name}>
              <Chip label={name} size="small" sx={projectChipSx} />
            </Tooltip>
          ))}
          {hiddenProjects.length > 0 && (
            <Tooltip
              arrow
              title={
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, py: 0.5 }}>
                  {hiddenProjects.map((name) => (
                    <Box key={name} component="span">
                      {name}
                    </Box>
                  ))}
                </Box>
              }
            >
              <Chip label={`+${hiddenProjects.length}`} size="small" sx={{ ...projectChipSx, cursor: 'default', flexShrink: 0 }} />
            </Tooltip>
          )}
        </Stack>
      ) : (
        <Box sx={{ width: '100%', ml: 1 }} />
      )}
      {/* {Role !== 'Security' && <Notification />} I disabled due to demo */}

      <Profile />
    </>
  );
};

export default HeaderContent;
